import { Box, Grid, InputLabel, MenuItem, Select, TextField } from '@material-ui/core';
import React, { useMemo } from 'react';
import { GetDates } from '../../../util/date';
import classnames from 'classnames';
import { initCaseSupportingImgs } from '../../pagesUtils';
import useCaseSupportingFileInputFunc from '../../../hooks/useCaseSupportingFileInputFunc';
import CaseSupportingFileInput, {
    RemoveAllCaseSupportingFilesBtn,
} from '../../../components/CaseSupportingFileInput/CaseSupportingFileInput';
export default function ReceivedGrid({
    selectedExpectedTxDate,
    selectedAmPmTxDate,
    expectedDateOnChange,
    expectedAmPmOnChange,
    newStatus,
    classes,
    remarks,
    handleRemarksChange,
    disabled,
    resetCaseSupportingImgs,
    removeCaseSupportingImgs,
    caseSupportingImgs = initCaseSupportingImgs,
    setCaseSupportingImgs,
    setCaseSupportingImgsSubject,
}) {
    const {
        assignRef,
        handleSelectPasteBoard,
        pasteBoardSelected,
        handleFileInput,
        handlePaste,
        handleRemoveAllImgs,
        handleRemoveImg,
    } = useCaseSupportingFileInputFunc({
        setCaseSupportingImgs: setCaseSupportingImgs,
        resetCaseSupportingImgs: resetCaseSupportingImgs,
        removeCaseSupportingImgs: removeCaseSupportingImgs,
    });

    const inputLabel = useMemo(() => {
        if (newStatus === 'RETRACK_ALL_MATERIAL_RECEIVED') {
            return 'Expected retrack report upload Date';
        }
        return 'Expected TX Plan delivery Date';
    }, [newStatus]);

    return (
        <Grid container spacing={4}>
            <Grid item xs={12} sm={4}></Grid>
            <Grid item xs={12} sm={8}>
                <Grid container spacing={3}>
                    <Grid item md={6}>
                        <InputLabel>{inputLabel}</InputLabel>
                        <Box mt={1}>
                            <Select value={selectedExpectedTxDate} displayEmpty onChange={expectedDateOnChange}>
                                {GetDates(new Date(), 16).map((nextDate, i) => {
                                    return <MenuItem value={nextDate}>{nextDate}</MenuItem>;
                                })}
                            </Select>
                        </Box>
                    </Grid>
                    <Grid item md={6}>
                        <InputLabel>AM/PM</InputLabel>
                        <Box mt={1}>
                            <Select value={selectedAmPmTxDate} displayEmpty onChange={expectedAmPmOnChange}>
                                <MenuItem value={'AM'}>AM</MenuItem>
                                <MenuItem value={'PM'}>PM</MenuItem>
                            </Select>
                        </Box>
                    </Grid>
                </Grid>
            </Grid>

            <Grid item xs={12} sm={4}>
                <label>
                    <strong>Remarks For Confirmed Materials Received:</strong>
                </label>
                :
            </Grid>

            <Grid item xs={12} sm={8}>
                <TextField
                    disabled={disabled}
                    className={classnames(classes.textField, classes.dense)}
                    margin="dense"
                    variant="outlined"
                    fullWidth
                    multiline
                    value={remarks}
                    onChange={handleRemarksChange}
                />
            </Grid>

            <Grid item xs={12}>
                <div>
                    <RemoveAllCaseSupportingFilesBtn handleRemoveAllImgs={handleRemoveAllImgs} />

                    <Grid>
                        {caseSupportingImgs.map((image, index) => {
                            console.log('image => ', image);
                            return (
                                <CaseSupportingFileInput
                                    imgIndex={index}
                                    data={image}
                                    ref={assignRef(index)}
                                    handleSelectPasteBoard={handleSelectPasteBoard}
                                    pasteBoardSelected={pasteBoardSelected[`pasteBoard${index}`]}
                                    handleRemoveImg={handleRemoveImg}
                                    handlePaste={handlePaste}
                                    handleFileInput={handleFileInput}
                                    handleSubjectInput={setCaseSupportingImgsSubject}
                                />
                            );
                        })}
                    </Grid>
                </div>
            </Grid>
        </Grid>
    );
}
